import { CustomTabPanel } from "@/erp/sale";
import { a11yProps, EstadoPreventaEnum, ROUTER_PATHS, sizeTab, texto } from "@/shared";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import TablePreventaPymes from "../../shared/componente/table_preventa_pymes/TablePreventaPymes";

export default function PreventaPymesPage() {

  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      title={"Preventas PYMES"}
      visibleReport={true}
      enableRedirect={true}
      urlRedirect={`${ROUTER_PATHS.ventasPymes.preventaProspectoCreate}`}
      textRedirect='Oportunidad con Proyecto Previo'
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Preventas'} {...a11yProps(0)} />
          <Tab label={texto.realizadas} {...a11yProps(1)} />
          <Tab label={texto.cancelado} {...a11yProps(2)} />
          <Tab label={'Pendiente Contrato'} {...a11yProps(3)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TablePreventaPymes
          estado_preventa={EstadoPreventaEnum.EN_ESPERA}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TablePreventaPymes
          estado_preventa={EstadoPreventaEnum.EN_PROCESO}
          enable_action={false}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <TablePreventaPymes
          estado_preventa={EstadoPreventaEnum.CANCELADO}
          enable_action={false}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={3}>
        <TablePreventaPymes
          estado_preventa={EstadoPreventaEnum.PENDIENTE_DOCUMENTOS}
          pre_requiere_contrato_fisico={true}
        />
      </CustomTabPanel>

    </SingleTableBoxScene>
  )
}